module.exports = __webpack_public_path__ + "img/033-lollipop.c45cbc85.png";